import { ReactElement } from 'react';

import { PrintTemplateClickRegisterAction } from '~libs.desktop.shared.document-template';

import { ConsentsAndAuthorizationsDocumentTemplateModalOpener } from '../../../ConsentsAndAuthorizationsDocumentTemplateModal/ConsentsAndAuthorizationsDocumentTemplateModal.opener';

import { ConsentsAndAuthorizationsDocumentsFillButton } from './ConsentsAndAuthorizationsDocumentsFillButton';

type ConsentsAndAuthorizationsDocumentsOptionsCellProps = Readonly<{
   printTemplateId: number;
   printTemplateName: string;
   patientId: number;
   onApproveAndPrint: VoidFunction;
}>;

export const ConsentsAndAuthorizationsDocumentsOptionsCell = (
   props: ConsentsAndAuthorizationsDocumentsOptionsCellProps
): ReactElement => {
   return (
      <PrintTemplateClickRegisterAction>
         {({ registerClick }) => (
            <ConsentsAndAuthorizationsDocumentTemplateModalOpener
               onApproveAndPrint={props.onApproveAndPrint}
               patientId={props.patientId}
               printTemplateId={props.printTemplateId}
               printTemplateName={props.printTemplateName}
            >
               {({ openModal }) => (
                  <ConsentsAndAuthorizationsDocumentsFillButton
                     onClick={() => {
                        registerClick({
                           printTemplateId: props.printTemplateId,
                           printTemplateName: props.printTemplateName,
                        });
                        openModal();
                     }}
                     testId={`${props.printTemplateId}-${props.printTemplateName}`}
                  />
               )}
            </ConsentsAndAuthorizationsDocumentTemplateModalOpener>
         )}
      </PrintTemplateClickRegisterAction>
   );
};
